import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const schedulesStartRequest = () => {
  return {
    type: 'SCHEDULES_START_REQUEST'
  };
};

export const schedulesEndRequest = () => {
  return {
    type: 'SCHEDULES_END_REQUEST'
  };
};

export const getAllSchedulesSuccess = ({ data }) => {
  return {
    type: 'SCHEDULES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllSchedulesError = error => {
  return {
    type: 'SCHEDULES_GET_ALL_ERROR',
    payload: error
  };
};

export const addSchedulesSuccess = ({ data }) => {
  return {
    type: 'SCHEDULES_ADD_SUCCESS',
    payload: data
  };
};

export const addSchedulesError = error => {
  return {
    type: 'SCHEDULES_ADD_ERROR',
    payload: error
  };
};

export const editSchedulesSuccess = ({ data }) => {
  return {
    type: 'SCHEDULES_EDIT_SUCCESS',
    payload: data
  };
};

export const editSchedulesError = error => {
  return {
    type: 'SCHEDULES_EDIT_ERROR',
    payload: error
  };
};

export const removeSchedulesSuccess = id => {
  return {
    type: 'SCHEDULES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeSchedulesError = error => {
  return {
    type: 'SCHEDULES_REMOVE_ERROR',
    payload: error
  };
};

export const schedulesModifyStore = ({ data }) => {
  return {
    type: 'SCHEDULES_MODIFY_STORE',
    payload: data
  };
};

export const addSchedules = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(schedulesStartRequest());
      const response = await api().post('/api/schedules', data);
      dispatch(addSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'schedules',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addSchedulesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(schedulesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllSchedules = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(schedulesStartRequest());
      const response = await api().get('/api/schedules', { params });
      dispatch(getAllSchedulesSuccess(response));
    } catch (err) {
      dispatch(getAllSchedulesError(err));
    } finally {
      dispatch(schedulesEndRequest());
    }
  };
};

export const editSchedules = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(schedulesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(schedulesStartRequest());
      const id = data._id;
      const response = await api().put('/api/schedules/' + id, data);
      dispatch(editSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'schedules',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/schedules'));
      }
    } catch (err) {
      dispatch(editSchedulesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeSchedules = id => {
  return async dispatch => {
    try {
      dispatch(schedulesStartRequest());
      await api().delete('/api/schedules/' + id);
      dispatch(removeSchedulesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'schedules',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Agendamento removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeSchedulesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover agendamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(schedulesEndRequest());
    }
  };
};

export const restoreSchedules = data => {
  return async dispatch => {
    try {
      dispatch(schedulesStartRequest());
      const id = data._id;
      const response = await api().put('/api/schedules/' + id, data);
      dispatch(editSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'schedules',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Agendamento restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editSchedulesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar agendamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(schedulesEndRequest());
    }
  };
};

export const closeSchedules = data => {
  return async dispatch => {
    try {
      dispatch(schedulesStartRequest());
      const id = data._id;
      const response = await api().put('/api/schedules/' + id, data);
      dispatch(editSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'schedules',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Agendamento finalizado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editSchedulesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao finalizar agendamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(schedulesEndRequest());
    }
  };
};

export const cloneSchedules = data => {
  return async dispatch => {
    try {
      dispatch(schedulesStartRequest());
      const response = await api().post('/api/schedules', data);
      dispatch(addSchedulesSuccess(response));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Agendamento clonado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(addSchedulesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao clonar agendamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(schedulesEndRequest());
    }
  };
};
